import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import get from 'lodash.get';

const PdpSharedBlurbShippingCustomQuote = ({ transaction, currency }) => {
    const quotes = get(transaction, 'shipmentQuotes');
    const customQuotes = (quotes || []).filter(quote => quote.isCustom && quote.status !== 'NEW');
    const customQuote = customQuotes.length && customQuotes[customQuotes.length - 1];

    if (!customQuote) {
        return null;
    }

    let customQuoteCopy;
    let customQuoteAmount;
    let customQuoteFormattedAmount;

    const customQuoteIsRequest = customQuote.status === 'REQUESTED';
    if (customQuoteIsRequest) {
        customQuoteCopy = (
            <FormattedMessage
                id="pdp.PdpSharedBlurbShippingCustomQuote.customQuotePending"
                defaultMessage="Custom Quote Pending"
            />
        );
    } else {
        customQuoteAmount = (get(customQuote, 'totalAmount.convertedAmountList') || []).find(
            amount => amount.currency === currency
        );

        customQuoteFormattedAmount = customQuoteAmount && (
            <FormattedNumber
                value={customQuoteAmount.amount}
                style="currency"
                currency={currency}
            />
        );
        customQuoteCopy = (
            <FormattedMessage
                id="pdp.PdpSharedShippingBlurbCustomQuote.customQuote"
                defaultMessage="{amount} Custom Quote"
                values={{ amount: customQuoteFormattedAmount }}
            />
        );
    }

    return customQuoteCopy;
};

PdpSharedBlurbShippingCustomQuote.propTypes = {
    transaction: PropTypes.object,
    currency: PropTypes.string,
};

export default createFragmentContainer(PdpSharedBlurbShippingCustomQuote, {
    transaction: graphql`
        fragment PdpSharedBlurbShippingCustomQuote_transaction on Transaction {
            shipmentQuotes {
                isCustom
                status
                totalAmount {
                    convertedAmountList {
                        amount
                        currency
                    }
                }
            }
        }
    `,
});
